var _AuthNamespace_instances, _AuthNamespace_fetchOTT, _AuthNamespace_fetchToken, _AuthNamespace_fetchAccessToken;
import { __classPrivateFieldGet } from "tslib";
import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
import { PrivateAPINamespace } from '../PrivateAPINamespace';
var AuthNamespaceErrorCode;
(function (AuthNamespaceErrorCode) {
    AuthNamespaceErrorCode["TokenRequestFailed"] = "TokenRequestFailed";
    AuthNamespaceErrorCode["OTTokenRequestFailed"] = "OTTokenRequestFailed";
})(AuthNamespaceErrorCode || (AuthNamespaceErrorCode = {}));
class AuthNamespaceError extends BaseError {
    constructor(message, code) {
        super(message, code, 'Auth Strategy Error');
        this.state = {};
    }
    withAppDefinitionId(appDefinitionId) {
        this.state = { ...this.state, appDefinitionId };
        return this;
    }
}
export const createAuthNamespaceError = createErrorBuilder(AuthNamespaceError);
/**
 * https://dev.wix.com/docs/rnd-general/articles/p13n-guidelines-aips/guidance-aips/wix-api-basics/1002-identities-authentication
 * metasite token
 */
// const META_SITE_APPLICATION_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';
const META_SITE_APPLICATION_ID = '-666';
export class AuthNamespace extends PrivateAPINamespace {
    constructor() {
        super(...arguments);
        _AuthNamespace_instances.add(this);
    }
    async getAccessToken(appDefinitionId, metaSiteId) {
        const originDomain = globalThis.location?.origin ?? '';
        return (await __classPrivateFieldGet(this, _AuthNamespace_instances, "m", _AuthNamespace_fetchAccessToken).call(this, {
            appDefinitionId,
            metaSiteId,
            originDomain,
        }));
    }
}
_AuthNamespace_instances = new WeakSet(), _AuthNamespace_fetchOTT = async function _AuthNamespace_fetchOTT(authInstance, payload) {
    const res = await fetch('/_api/one-time-token/v1/tokens', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
            Authorization: authInstance,
        },
    });
    if (!res.ok) {
        throw createAuthNamespaceError(AuthNamespaceErrorCode.OTTokenRequestFailed).withAppDefinitionId(payload.tokenMetadata.appId);
    }
    const createOTTokenResponse = (await res.json());
    const otp = createOTTokenResponse.tokenResult?.token?.value;
    if (!otp) {
        throw createAuthNamespaceError(AuthNamespaceErrorCode.OTTokenRequestFailed, 'there is no ott value').withAppDefinitionId(payload.tokenMetadata.appId);
    }
    return otp;
}, _AuthNamespace_fetchToken = async function _AuthNamespace_fetchToken(authInstance, payload) {
    const res = await fetch('/_api/token-creator/v1/token', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
            Authorization: authInstance,
        },
    });
    return (await res.json());
}, _AuthNamespace_fetchAccessToken = async function _AuthNamespace_fetchAccessToken(params) {
    const authInstance = this.ps.ds.platform.getAppDataByApplicationId(META_SITE_APPLICATION_ID)?.instance;
    try {
        const otp = await __classPrivateFieldGet(this, _AuthNamespace_instances, "m", _AuthNamespace_fetchOTT).call(this, authInstance, {
            tokenMetadata: {
                appId: params.appDefinitionId,
                originDomain: params.originDomain,
                siteId: params.metaSiteId,
            },
        });
        const createTokenResponse = await __classPrivateFieldGet(this, _AuthNamespace_instances, "m", _AuthNamespace_fetchToken).call(this, authInstance, {
            otp,
        });
        return createTokenResponse.token;
    }
    catch (e) {
        throw createAuthNamespaceError(AuthNamespaceErrorCode.TokenRequestFailed).withAppDefinitionId(params.appDefinitionId);
    }
};
AuthNamespace.namespace = 'auth';
//# sourceMappingURL=AuthNamespace.js.map